// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectDataSourcePopup from "../SelectDataSourcePopup";
import { FIELDS } from "../../../constants";

import { nukeCSVData } from "../../../actions/FieldsSetting/fieldsSettingActions";

const { DATA_STUDIO_VIEW } = FIELDS;

class DataSourceIntegrationBox extends Component {
  state = { showDataSoureIntegrationPopup: false };

  componentDidUpdate(props) {
    const { crmConfig, data } = this.props;
    const isAuthenticated = crmConfig ? crmConfig.isAuthenticated : false;
    if (
      data.name !== "csv" &&
      data.name === props.dataSourceSelected &&
      !isAuthenticated
    ) {
      this.props.updateDataSourceSelected("");
      this.setState({ showDataSoureIntegrationPopup: true });
    }
  }

  _handleIntegrationPopup = () => {
    const { crmConfig, data } = this.props;
    const isAuthenticated = crmConfig ? crmConfig.isAuthenticated : false;
    if (!isAuthenticated) {
      if (data.id === "CSV") {
        this.props.updateDataSourceSelected(data.name);
        this.props.updateDataStdioView(DATA_STUDIO_VIEW.CONFIG_VIEW);
        this.props.initFieldsMappingData(data.name);
        this.props.nukeCSVData();
      } else {
        this.setState({ showDataSoureIntegrationPopup: true });
        this.props.updateDataSourceSelected("");
      }
    } else if (data.id === "CSV") {
      this.props.updateDataSourceSelected(data.name);
      this.props.updateDataStdioView(DATA_STUDIO_VIEW.CONFIG_VIEW);
      this.props.initFieldsMappingData(data.name);
      this.props.nukeCSVData();
    } else {
      this.props.updateDataSourceSelected(data.name);
      this.props.updateDataStdioView(DATA_STUDIO_VIEW.CONFIG_VIEW);
      this.props.initFieldsMappingData(data.name);
    }
  };

  _handleEditIntegrationPopup = () => {
    this.setState({ showDataSoureIntegrationPopup: true });
    this.props.updateDataSourceSelected("");
  };

  render() {
    const { showDataSoureIntegrationPopup } = this.state;
    const { crmConfig } = this.props;

    const isAuthenticated = crmConfig ? crmConfig.isAuthenticated : false;
    console.debug(
      "showDataSoureIntegrationPopup",
      showDataSoureIntegrationPopup,
    );
    if (showDataSoureIntegrationPopup) {
      return (
        <SelectDataSourcePopup
          data={this.props.data}
          crmParam={this.props.data.name}
          config={crmConfig}
          closePopup={() =>
            this.setState({ showDataSoureIntegrationPopup: false })
          }
        />
      );
    }
    return (
      <div className="integration-client-box col-md-4">
        {isAuthenticated ? (
          <span className="integration-client-integrated">
            <FontAwesomeIcon icon={["far", "check"]} />
          </span>
        ) : null}
        <div
          className={`integration-client-link${
            isAuthenticated ? " integration-client-linkactive" : ""
          }`}>
          <div
            className="integration-client col-md-12"
            key={this.props.data.fullpath}
            id={`settings-sidebar-crm-${this.props.data.name}`}
            role="button"
            tabIndex="0"
            onClick={this._handleIntegrationPopup}
            onKeyPress={() => {}}>
            <div className="integration-logo">
              <img
                className="integration-logo"
                src={this.props.data.logopath}
                alt="integration-logo"
              />
            </div>
          </div>
        </div>

        {isAuthenticated ? (
          <span
            role="button"
            tabIndex="0"
            className="integration-client-integrated-edit"
            onClick={this._handleEditIntegrationPopup}
            onKeyPress={() => {}}>
            <FontAwesomeIcon icon={["far", "edit"]} />
          </span>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { crmAllUserConfig } = state.SettingsStore;
  const { data } = props;
  let crmConfig = {
    isAuthenticated: false,
  };
  if (Array.isArray(crmAllUserConfig) && data) {
    const config = crmAllUserConfig.find(cfg => cfg.crm === data.id);
    if (config) {
      crmConfig = {
        crm: config.crm,
        isAuthenticated: config.is_authenticated,
        clientId: config.client_id,
        clientSecret: config.client_secret,
        instanceUrl: config.instance_url,
        redirectUrl: config.redirect_url,
        webhookKey: config.webhook_key,
        scopes: config.scopes,
      };
    }
  }
  return { crmConfig };
};

const mapDispatchToProps = {
  nukeCSVData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataSourceIntegrationBox);
